import { IdentifierDTO } from '@zazume/zzm-base';
import { doDelete, doGet, doPost, doPut, toPaginatedURL } from '../../helpers';
import { Comment } from '#/models/comment/Comment';
import { PaginationOptions } from '#/hooks';

export const comments = {
  getAll: (relatedModelId: IdentifierDTO) =>
    (pagination: PaginationOptions) =>
      doGet<Comment[]>(toPaginatedURL(`/dashboard/comments/${relatedModelId}`, pagination)),
  getArchived: (relatedModelId: IdentifierDTO) =>
    (pagination: PaginationOptions) =>
      doGet<Comment[]>(toPaginatedURL(`/dashboard/comments/${relatedModelId}?archived=true`, pagination)),
  create: (relatedModelId: IdentifierDTO, relatedModelName: Comment['relatedModelName']) => (content: string) =>
    doPost<IdentifierDTO>(`/dashboard/comments/${relatedModelName}/${relatedModelId}`, { content }),
  archive: (commentId: IdentifierDTO) =>
    doPut<void>(`/dashboard/comments/archive/${commentId}`),
  restore: (commentId: IdentifierDTO) =>
    doPut<void>(`/dashboard/comments/restore/${commentId}`),
  delete: (commentId: IdentifierDTO) =>
    doDelete(`/dashboard/comments/${commentId}`)
};
